import { useInfiniteQuery } from "@tanstack/react-query";
import apiClient from "../../../lib/api_client";

export const pdfDownloadLink = async (orderId) => {
  try {
    const response = await apiClient.get(`/download_Invoice/${orderId}`);

    return response;
  } catch (error) {
    return error;
  }
};

const catalogBaseURL = process.env.REACT_APP_SERVER_URL?.replace(
  "/api/v8/select",
  "/api/v1/catalog"
);

export const fetchCollections = async () => {
  const res = await apiClient.get("/getCollections");
  return res.data?.data || [];
};

export const createCatalog = async (payload) => {
  try {
    const response = await apiClient.post(`/createCatalog`, payload, {
      baseURL: catalogBaseURL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const syncOrder = async (payload) => {
  try {
    const {orderNumber , projectName} = payload;
    
    const response = await apiClient.post(`/syncOrder`,{
      orderNumber,
      projectName

      
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const OrderTableDetails = async ({
//   page,
//   limit,
//   searchBy,
//   filterBy,
//   startDate,
//   endDate,
// }) => {
//   const response = await apiClient.post(`/getAllOrders`, {
//     page,
//     limit,
//     searchBy,
//     filterBy,
//     startDate,
//     endDate,
//   });

//   console.log("response",response )

//   return response;
// };

export const OrderTableDetails = async ({
  page,
  limit,
  searchBy,
  filterBy,
  startDate,
  endDate,
  eventTypeId,
}) => {
  try {
    const response = await apiClient.post(`/getAllOrders`, {
      page,
      limit,
      searchBy,
      filterBy,
      startDate,
      endDate,
      eventTypeId,
    });

    return response.data;
  } catch (err) {
    console.log("API error in OrderTableDetails:", err?.response || err);
    return err?.response?.data;
  }
};


export const useOrderTableDetails = ({
  limit = 5,
  searchBy = "",
  filterBy = "",
  startDate,
  endDate,
  eventTypeId = "",
}) => {
  return useInfiniteQuery({
    queryKey: [
      "OrderTableDetails",
      limit,
      searchBy,
      startDate,
      filterBy,
      endDate,
      eventTypeId,
    ],
    queryFn: ({ pageParam = 1 }) =>
      OrderTableDetails({
        page: pageParam,
        limit,
        searchBy,
        filterBy,
        startDate,
        endDate,
        eventTypeId,
      }),
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = allPages.length;
      const totalPages = lastPage?.data?.totalPages || 0;
      if (currentPage < totalPages) {
        return currentPage + 1;
      }
      return undefined;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: false,
  });
};
